import Vue from 'www/vue_components'
import ClubInfoBanner from 'www/vue_components/common/Club/components/core/ClubInfoBanner/ClubInfoBanner.vue'

const vueInstances = []

function initClubInfoBanner() {
  const mountElements = [...document.querySelectorAll('.vue-club-info-banner-mount')]

  vueInstances.forEach(vm => vm.$destroy())
  vueInstances.length = 0

  mountElements.forEach(el => vueInstances.push(
    new Vue({
      el,
      components: {
        ClubInfoBanner,
      },
    }),
  ))
}

document.addEventListener('initClubInfoBanner', initClubInfoBanner, false)

initClubInfoBanner()
